module.exports = __webpack_public_path__ + "img/mayBanner_1248.cecfe28d.png";